(function($, undefined) {
  'use strict';
  var doc = $(document);
  var currPage;
  var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
  var body;
  var items;
  var checkLabel;
  var checkboxItems;
  var checkboxItemsInner;
  var file;
  var fileInput;
  var formSwitch;
  var formCheck;
  var selectCountry;
  var dateInput;
  var dayOfYearInput;

  var validateForm = function(ctn) {
    ctn.each(function() {
      var t = $(this);
      var toValidateItems = $('.form-input:not(.select-state-input:not(.selected))', t).filter((i, el) => {
        const $el = $(el);
        const noParentToIgnore = $el.closest('.js-form-ignore-as-child').length == 0;
        const parentIsMainForm = $el.closest('.js-form-ignore-as-child').length != 0 && $el.closest('.js-form-ignore-as-child').is(t);
        return noParentToIgnore || parentIsMainForm;
      });
      var toValidateUpload = $('.form-input-upload.required', t);
      var toValidateCheck = $('.form-check-input.required', t);
      var password = $('.js-password', t);
      var passwordConfirm = $('.js-password-confirm', t);
      var email = $('.js-email', t);
      var emailConfirm = $('.js-email-confirm', t);
      var btn = $('.js-form-btn', t);
      var isOk = true;
      var passwordOk = true;
      var termsOk = true;
      var checkOk = true;
      var emailOk = true;
      var fieldsErrorMessage = $('.js-form-error-message.fields', t);
      var fieldsErrorCheckbox = $('.js-form-error-message.checkbox', t);
      var fieldsErrorTerms = $('.js-form-error-message.terms', t);
      var fieldsErrorPassword = $('.js-form-error-message.password', t);
      var fieldsErrorEmail = $('.js-form-error-message.email-check', t);

      toValidateItems.each(function() {
        var tChild = $(this);
        validateField(tChild);
        if (tChild.hasClass('error')) {
          isOk = false;
        }
      });

      toValidateUpload.each(function() {
        var tUpload = $(this);
        var input = $('.form-input-upload-input', tUpload);

        if (input.val() === '') {
          tUpload.addClass('error');
        }

        if (tUpload.hasClass('error')) {
          isOk = false;
        }
      });

      toValidateCheck.each(function() {
        var tCheck = $(this);
        var tCtn = tCheck.closest('.form-checkbox-ctn');

        if (!tCheck.is(':checked')) {
          tCtn.addClass('error');

          if (tCtn.attr('name') !== 'terms') {
            checkOk = false;
          }
        } else {
          tCtn.removeClass('error');
        }

        if (tCheck.attr('name') === 'terms' && tCtn.hasClass('error')) {
          termsOk = false;
        }

        if (tCtn.hasClass('error')) {
          termsOk = false;
        }
      });

      if (
        password.length !== 0 &&
        passwordConfirm.length !== 0 &&
        (password.val() !== passwordConfirm.val() || (password.val().length === 0 && password.hasClass('required')))
      ) {
        if (password.val().length === 0) {
          password.removeClass('success').addClass('error');
          passwordOk = false;
        } else {
          password.addClass('success').removeClass('error');
          passwordOk = true;
        }

        if (password.val() !== passwordConfirm.val() || (passwordConfirm.val().length === 0 && passwordConfirm.hasClass('required'))) {
          passwordConfirm.removeClass('success').addClass('error');
          passwordOk = false;
        } else {
          passwordConfirm.removeClass('error');
          passwordOk = true;

          if (password.val().length !== 0) {
            passwordConfirm.addClass('success');
          }
        }
      }

      if (
        email.length !== 0 &&
        emailConfirm.length !== 0 &&
        (email.val() !== emailConfirm.val() || email.val().length === 0)
      ) {
        if (email.val().length === 0) {
          email.removeClass('success').addClass('error');
          emailOk = false;
        } else {
          email.addClass('success').removeClass('error');
          emailOk = true;
        }

        if (email.val() !== emailConfirm.val() || email.val().length === 0) {
          emailConfirm.removeClass('success').addClass('error');
          emailOk = false;
        } else {
          emailConfirm.removeClass('error');
          emailOk = true;

          if (email.val().length !== 0) {
            emailConfirm.addClass('success');
          }
        }
      }

      t.addClass('is-checked');

      if (!termsOk) {
        fieldsErrorTerms.slideDown(300);
      } else {
        fieldsErrorTerms.slideUp(300);
      }

      if (!checkOk) {
        fieldsErrorCheckbox.slideDown(300);
      } else {
        fieldsErrorCheckbox.slideUp(300);
      }

      if (password.length !== 0 && passwordConfirm.length !== 0) {
        if (password.length !== 0 && passwordOk) {
          ctn.addClass('has-password');
          password.add(passwordConfirm).removeClass('error');
          fieldsErrorPassword.slideUp(300);
        } else {
          ctn.removeClass('has-password');
          password.add(passwordConfirm).addClass('error');
          fieldsErrorPassword.slideDown(300);
        }
      }

      if (email.length !== 0 && emailConfirm.length !== 0) {
        if (email.length !== 0 && emailOk) {
          ctn.addClass('has-email');
          email.add(emailConfirm).removeClass('error');
          fieldsErrorEmail.slideUp(300);
        } else {
          ctn.removeClass('has-email');
          email.add(emailConfirm).addClass('error');
          fieldsErrorEmail.slideDown(300);
        }
      }

      if (!isOk) {
        fieldsErrorMessage.slideDown(300);
      } else {
        fieldsErrorMessage.slideUp(300);
      }

      if (!isOk || !passwordOk || !termsOk || !checkOk || !emailOk) {
        btn.addClass('disabled');
        ctn.addClass('has-error');

        if (!passwordOk && password.hasClass('required')) {
          ctn.addClass('error-password');
        } else {
          ctn.removeClass('error-password');
        }
        return false;
      } else {
        btn.removeClass('disabled');
        ctn.removeClass('has-error').removeClass('error-password');

        fieldsErrorTerms.slideUp(300);
        return true;
      }
    });
  };

  var validateField = function(elt) {
    var tag = elt[0].tagName;
    var type = elt.attr('type');
    var val = elt.val();
    var attrClass = elt.attr('data-validator-apply-class-on');
    var classTarget = attrClass !== undefined ? elt.closest(attrClass) : elt;

    // Choises for validate are : "email", "url", "tel" or "default". By default, an input type email takes the email validation,
    // the input type tel takes the tel validation and if the validate value is "default", then it do a normal check if the input has char
    var validate = elt.attr('data-validate');
    var reEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    var reEmailComma = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})(,(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,}))*$/i;
    var reUrl = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(:[0-9]+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
    var reTel = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
    var emailValid = true;
    var whiteSpaceValid = true;
    var urlValid = true;
    var telValid = true;
    var inputValid = true;
    var numberValid = true;

    if (val == null || !val.replace(/\s/g, '').length) {
      if(elt.attr("class").indexOf("updated-select-input-hidden") == -1){
        whiteSpaceValid = false;
      }
    }

    if (tag === 'INPUT' && (type === 'email' || validate === 'email') && validate !== 'default') {
      emailValid = reEmail.test(val);
    } else if (tag === 'INPUT' && validate === 'email-comma' && validate !== 'default') {
      emailValid = reEmailComma.test(val);
    } else if (tag === 'INPUT' && validate === 'url' && validate !== 'default') {
      urlValid = reUrl.test(val);
    } else if (
      tag === 'INPUT' &&
      (type === 'tel' || validate === 'tel') &&
      validate !== 'default'
    ) {
      telValid = reTel.test(val);
    } else if (tag === 'INPUT' && (type === 'number' || validate === 'number') && validate !== 'default') {
      numberValid = /^\d*$/.test(val);
    } else if (elt.hasClass('form-input-upload-input')) {
      if (classTarget.add(elt).hasClass('required') && elt.val() !== '') {
        classTarget
          .add(elt)
          .removeClass('error')
          .addClass('success');
      } else {
        classTarget
          .add(elt)
          .addClass('error')
          .removeClass('success');
      }
    } else {
      classTarget
        .add(elt)
        .addClass('success')
        .removeClass('error');
      if (classTarget.hasClass('required') && (val == null || $.trim(val).length === 0)) {
        classTarget
          .add(elt)
          .removeClass('success')
          .addClass('error');
        inputValid = false;
      } else if (!classTarget.hasClass('required') && (val == null || val.length === 0)) {
        classTarget
          .add(elt)
          .removeClass('success')
          .removeClass('error');
      }
    }

    if (emailValid && urlValid && telValid && inputValid && whiteSpaceValid && numberValid) {
      classTarget
        .add(elt)
        .removeClass('error')
        .addClass('success');
    } else if ((val === null || val.length === 0) && !classTarget.hasClass('required')) {
      classTarget
        .add(elt)
        .removeClass('error')
        .removeClass('success');
    } else {
      classTarget
        .add(elt)
        .addClass('error')
        .removeClass('success');
    }
  };

  var formItemsBlur = function(t) {
    var elt = t.target === undefined ? t : $(this);
    var ctn = elt.closest('.form-input');
    var form = ctn.closest('.js-form');

    validateField(elt);

    if (form.hasClass('is-checked')) {
      validateForm(form);
    }
  };

  var formCheckChange = function() {
    var t = $(this);
    var ctn = t.closest('.form-checkbox-ctn');
    var form = ctn.closest('.js-form');
    
    if (form.hasClass('is-checked')) {
      validateForm(form);

      if (t.is(':checked')) {
        ctn.removeClass('error');
      }
    }
  };

  var checkLabelClick = function() {
    var t = $(this);
    var ctn = t.closest('.register-checkbox');

    if (input.hasClass('is-checked')) {
      input.removeClass('is-checked');
    } else {
      input.addClass('is-checked');
    }
  };

  var toggleCheckbox = function() {
    var t = $(this);
    var ctn = t.closest('.form-input-checkbox');
    var input = $('.form-input-checkbox-input', t);
    
    if (ctn.hasClass('checked')) {
      ctn.removeClass('checked');
      input.removeAttr('checked');
    } else {
      ctn.addClass('checked');
      input.attr('checked', 'checked');
    }
  };

  var fileInputChange = function() {
    var t = $(this);
    var label = t.closest('.form-input-upload-input-label');
    var labelDefault = label.attr('data-default-value');
    var labelValue = $('.form-input-upload-input-label-value', label);
    var ctn = t.closest(t.attr('data-validator-apply-class-on'));
    var form = ctn.closest('.js-form');

    if (t.val() !== '') {
      ctn.removeClass('error').addClass('success');
      labelValue.html(t.val().split('\\')[t.val().split('\\').length - 1]);
    } else {
      ctn.addClass('error').removeClass('success');
      labelValue.html(labelDefault);
    }

    if (form.hasClass('is-checked')) {
      validateForm(form);
    }
  };

  var formSwitchClick = function() {
    var t = $(this);
    var elem = $(t).find('.checkbox');

    t.find('.form-checkbox-slider').toggleClass('active');
    if (elem.prop('checked')) {
      elem.removeAttr('checked');
    } else {
      elem.attr('checked', 'checked');
    }
  };

  var updateStateSelect = function () {
    var t = $(this);
    var val = t.val();
    var id = t.attr('data-id');
    var statesCtn = $('.select-state-ctn[data-id="' + id + '"]');
    var selects = $('.form-select-ctn, .form-select-ctn .form-select', statesCtn);
    var useDisabled = t.hasClass('use-disabled');
    var currentSelect;
    var select, selectName;

    if (selects.length) {
      currentSelect = selects.filter('.selected');
      selects.removeClass('selected');
      selects.filter('.updated-select-input').each(function () {
        var select = $(this);
        
        select.parent().find(".select2.select2-container.select2-container--default").remove(); 
        window.parent.initializeSelect2(select);

        var name = select.attr('name');
        if (name.indexOf('XXXStateXXX') == -1) {
          select.attr('name', 'XXXStateXXX-' + name);
        }
      });

      if (useDisabled) {
        selects.attr('disabled', 'disabled');
        selects.val('');
      }

      if (val === 'CA' || val === 'CAN' || val === 'canada' || val === 'Canada') {
        select = $('.form-select-ctn.canada, .form-select-ctn.canada .form-select', statesCtn);
      } else if (val === 'US' || val === 'USA' || val === 'United-States' || val === 'united-states') {
        select = $('.form-select-ctn.us, .form-select-ctn.us .form-select', statesCtn);
      } else if (val != '') {
        select = $('.form-select-ctn.other, .form-select-ctn.other .form-select', statesCtn);
      }  else {
        select = currentSelect;
      }

      select.addClass('selected');

      if (val != '' && useDisabled) {
        select.removeAttr('disabled');
      }

      selectName = select.find('.form-select').attr('name');
      select.filter('.form-select').attr('name', selectName.replace(/XXXStateXXX\-/g, ''));
    }
  };
  
  var validatePasswordRestrictions = function(password) {
      var passwordRegex = new RegExp("^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])"); // (?=.{8,}) (?=.*[a-z])
      
      return passwordRegex.test(password);
  };

  var init = function() {
    body = $('body');
    items = $('.form-input:not([type=file])');

    checkLabel = $('.register-checkbox-label');
    checkboxItems = $('.form-input-checkbox');
    checkboxItemsInner = $('.form-input-checkbox-inner', checkboxItems);
    file = $('.form-input-upload');
    fileInput = $('.form-input-upload-input', file);
    formSwitch = $('.form-switch');
    formCheck = $('.form-check-input');
    selectCountry = $('.select-country-input');
    dateInput = $('.input_date');

    checkLabel.click(checkLabelClick);
    checkboxItemsInner.click(toggleCheckbox);
    fileInput.change(fileInputChange);
    formSwitch.click(formSwitchClick);
    formCheck.change(formCheckChange);
    $(selectCountry).on('select2:select', updateStateSelect);

    // http://t1m0n.name/air-datepicker/docs/
    dateInput.each((i, el) => {
      $(el).datepicker({
        language: "en",
        dateFormat: "yyyy-mm-dd",
        timeFormat: "hh:ii aa",
        onSelect: (formattedDate, date, inst) => {
          console.log(el);
          $(el).trigger("change");
        }
      });
    });
    

    items.each(function() {
      if (!$(this).hasClass('no-blur')) {
        $(this).blur(formItemsBlur);
      }
    });

    $(".password-view-btn").on("click",function(){
      var input = $(this).siblings('input');
      // if($(input).hasClass("fa-eye")){
        if($(this).hasClass("fa-eye")){
          $(this).removeClass("fa-eye");
          $(this).addClass("fa-eye-slash");
          $(input).attr("type","password");
        }else{
          $(this).removeClass("fa-eye-slash");
          $(this).addClass("fa-eye");
          $(input).attr("type","text");
        }
      
      // }
    });

    $(document).ready(function() {
      var selectDiv=$(".form-select-ctn");
		
      var selects=selectDiv.find(".updated-select-input");
      
      $(selects).each((i,el)=>{
        var select=$(el);
        if($(select).prop("id").indexOf("checklist-form-reminder")!=-1){
          $(select).prop("id",$(select).prop("id")+"-"+i);
        }
        window.parent.initializeSelect2(select);
      });

      var selectsHidden=selectDiv.find(".updated-select-input-hidden");
      $(selectsHidden).each((i,el)=>{
        var select=$(el);
        select.removeClass("form-select form-input");
        if(select.hasClass("required")) select.removeClass("required");
      });
    });
  };

  $(init);

  var form = Fw.component.export('form', {
    init: init,
    validateForm: validateForm,
    validatePasswordRestrictions: validatePasswordRestrictions
  });
})(jQuery);
